import React, { useId, useRef } from 'react';
import useCamada from './useCamada';

/**
 * FolhaCelular — folha que sobe da base da tela (menu "Mais" e escolhas no celular).
 * Esc e clique no véu fecham.
 */
export default function FolhaCelular({ aberto, onFechar, titulo, children }) {
  const gerado = useId();
  const tituloId = `folha-${gerado}-titulo`;
  const caixa = useRef(null);
  useCamada(aberto, onFechar, caixa);

  if (!aberto) return null;

  return (
    <div className="sj-veu sj-veu--folha" onMouseDown={(e) => { if (e.target === e.currentTarget) onFechar?.(); }}>
      <div ref={caixa} className="sj-folha" role="dialog" aria-modal="true" aria-labelledby={tituloId}>
        <h2 id={tituloId} className="titulo-cartao">{titulo}</h2>
        {children}
      </div>
    </div>
  );
}
